module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"Label":"Exporter"}}')
  delete Component.options._Ctor
}
